import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";

export const AddFeatures = {
  TimezoneText: styled.span`
    font-size: ${calcRem(12)};
    color: ${({ theme }) => theme.COLORS.WHITE}90;
    padding-left: 5px;
    position: absolute;
    right: 0;
    top: 10px;
  `,
  Clear: styled.div`
    ${FLEX.FlexStartStart};
    width: 100%;
    gap: 10px;
    color: ${({ theme }) => theme.COLORS.WHITE};
    font-size: ${calcRem(14)};
    padding-top: 20px;
  `,
  DeleteButton: styled.button`
    ${FLEX.FlexCenterCenter};
    color: ${COLORS.COMPANY};
    box-shadow: inset 0 0 0 1px ${COLORS.COMPANY};
    border-radius: 50%;
  `,
  SlideList: styled.div`
    padding: 0 10px 10px 0;
    ${FLEX.FlexStartStart};
    gap: 10px;
    flex-direction: column;
    width: calc(100% + 10px);
    margin-right: -10px;
    max-height: 300px;
    overflow-y: auto;
  `,
  AddSlideButton: styled.div`
    button {
      padding: 9px 18px;
    }
    svg {
      width: ${calcRem(12)};
      height: ${calcRem(12)};
      vertical-align: middle;
      margin: -2px 0 0 2px;
    }
  `,
  SlideItem: styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  `,
  SlideItemTitle: styled.h3`
    font-size: ${calcRem(14)};
    color: ${({ theme }) => theme.COLORS.WHITE};
    grid-column: 1 / 3;
    gap: 10px;
    ${FLEX.FlexStartCenter};
    padding-top: 10px;
  `,
  SlideItemInput: styled.div`
    ${FLEX.FlexStartStart};
    align-items: stretch;
    gap: 10px;
    width: 100%;
    position: relative;
    &.description {
      grid-column: 1 / 3;
      position: relative;
      padding-bottom: 10px;
      span {
        position: absolute;
        z-index: 1;
        right: 0;
        top: 100%;
        font-size: ${calcRem(12)};
        margin-top: -2px;
        color: ${({ theme }) => theme.COLORS.WHITE}70;
        b {
          color: ${({ theme }) => theme.COLORS.WHITE};
          font-weight: 500;
        }
      }
    }
    input[type="file"] {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
  `,
  ButtonWrapper: styled.div`
    ${FLEX.FlexCenterCenter};
    gap: 10px;
    width: 100%;
    padding-top: 20px;
  `,
  ScheduleDisplayPeriodItem: styled.div`
    ${FLEX.FlexStartStart};
    padding-bottom: 10px;
    column-gap: 10px;
    color: ${({ theme }) => theme.COLORS.WHITE};
    width: 100%;
    font-size: ${calcRem(14)};
    .common-modal-input {
      position: relative;
    }
    .ant-picker,
    .ant-picker-input {
      width: 100%;
      &.error {
        .ant-picker-input input {
          border-color: ${COLORS.VALIDATERED};
          background-color: #ffd5d5;
        }
      }
      .ant-picker-suffix {
        display: none;
      }
      .ant-picker-input input {
        width: 100%;
        border-radius: 2px;
        padding: 11px 15px;
        box-sizing: border-box;
        border: 1px solid #cacaca;
        background-color: ${COLORS.WHITE};
        color: ${COLORS.BLACK};
        font-size: ${calcRem(14)};
        height: 37px;

        &::placeholder {
          color: #abb5c5;
        }
        &:disabled {
          background-color: ${({ theme }) => theme.COLORS.DISABLED};
          border-color: ${({ theme }) => theme.COLORS.DISABLED_BORDER};
          color: ${({ theme }) =>
            theme.value === "light"
              ? `${theme.COLORS.WHITE}60`
              : theme.COLORS.LIGHTGRAY};
          cursor: not-allowed;
        }
      }
    }
    .ant-picker-outlined,
    .ant-picker-focused {
      border: 0 !important;
      outline: 0 !important;
      box-shadow: none !important;
    }
  `,
};

export const ViewFeatures = {
  SwiperButton: styled.span`
      color: ${({ theme }) => theme.COLORS.WHITE}80;
      opacity: 1;
      &:after {
        font-size: 70px;
        transform: scaleX(0.7);
      }
      &.swiper-button-prev {
        left: 30px;
      }
      &.swiper-button-next {
        right: 30px;
      }
      &.swiper-button-disabled {
        opacity: 0;
      }
    }
  `,
  DontShowAgainButton: styled.div`
    ${FLEX.FlexBetweenCenter};
    gap: 10px;
    width: 100%;
    > div {
      ${FLEX.FlexStartCenter};
      gap: 10px;
      color: ${({ theme }) => theme.COLORS.WHITE};
    }
    ${mediaQuery.isMobile} {
      padding: 0;
      button {
        width: auto;
      }
    }
  `,
  Container: styled.div`
    width: 100%;
    .swiper-pagination {
      overflow: visible;
    }
    .swiper-pagination-bullet {
      background-color: ${({ theme }) => theme.COLORS.BUTTONS3};
      opacity: 1;
      width: 11px;
      height: 11px;
      transform: scale(1);
      &.swiper-pagination-bullet-active {
        background-color: ${({ theme }) => theme.COLORS.BUTTONS2};
        opacity: 1;
        width: 11px;
        height: 11px;
        transform: scale(1.1);
      }
    }
  `,
  Content: styled.div`
    width: 100%;
    height: 100%;
    img,
    .no-image {
      width: 100%;
      aspect-ratio: 977/484;
      object-fit: cover;
    }
  `,
  SlidesWrapper: styled.div`
    width: 100%;
    height: 100%;
  `,
  SlidesItem: styled.div`
    width: 100%;
    height: 100%;
  `,
  SlideInfo: styled.div`
    width: 100%;
    height: 100%;
    color: ${({ theme }) => theme.COLORS.WHITE};
    padding: 20px 0 40px;
    h3 {
      font-size: ${calcRem(20)};
      font-weight: 600;
      padding-bottom: 10px;
    }
    p {
      font-size: ${calcRem(16)};
      line-height: 1.5;
    }
  `,
};
